import { usePortalApi } from "api/setup";
import { ApiError } from "api/shared";

import api from "config/urls/api";

export const useGetBillingPortalSession = () => {
  return usePortalApi<string, ApiError>(
    {
      url: api.account.billingPortalSession,
      method: "GET",
    },
    {
      manual: true,
    }
  );
};
